(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Ticket_status', Ticket_status);

    Ticket_status.$inject = ['$resource'];

    function Ticket_status ($resource) {
        var resourceUrl =  'api/ticket-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
